var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mb-4 pl-2" },
    [
      _c(
        "div",
        { staticClass: "flex pb-4", class: _vm.styles },
        [
          _vm.title && !_vm.showCustomTitle
            ? _c("h3", { staticClass: "text-lg font-bold text-gray-900" }, [
                _vm._v(" " + _vm._s(_vm.title) + " "),
              ])
            : _vm._e(),
          _vm._t("default"),
        ],
        2
      ),
      _c("ModalSectionsDivider"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }